"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangeObserver = void 0;
const IProduceValueEvents_1 = require("./IProduceValueEvents");
const ListenerCollection_1 = require("./ListenerCollection");
class ChangeObserver {
    constructor(producer, equalityChecker) {
        this.equalityChecker = equalityChecker;
        this.listenerCollection = new ListenerCollection_1.ListenerCollection();
        this.status = IProduceValueEvents_1.ValueStatus.Pending;
        this.value = null;
        this.error = null;
        producer.registerValueEventListener((status, error, value) => {
            if (this.shouldUpdateState(status, error, value)) {
                this.updateState(status, error, value);
            }
        });
    }
    getStatus() {
        return this.status;
    }
    getValue() {
        if (this.status !== IProduceValueEvents_1.ValueStatus.Ok) {
            throw new Error("getValue: value is not available");
        }
        return this.value;
    }
    registerValueEventListener(listener) {
        return this.listenerCollection.add(listener);
    }
    areErrorsEqual(err1, err2) {
        if (err1 === null || err2 === null)
            return err1 === err2;
        return err1.constructor === err2.constructor;
    }
    shouldUpdateState(status, error, value) {
        if (status !== this.status) {
            return true;
        }
        if (!this.areErrorsEqual(error, this.error)) {
            return true;
        }
        return !this.equalityChecker.check(value, this.value);
    }
    updateState(status, error, value) {
        this.status = status;
        this.value = value;
        this.error = error;
        this.invokeRegisteredListeners(status, error, value);
    }
    invokeRegisteredListeners(status, error, value) {
        this.listenerCollection.invoke(status, error, value);
    }
}
exports.ChangeObserver = ChangeObserver;
//# sourceMappingURL=ChangeObserver.js.map